export default "__VITE_ASSET__BD5$Bj51__"